import React, { useState, useEffect } from "react";
import { Table, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import useData from "../../hooks/useData";
import { Trash } from "react-feather"; // Предполагаемый путь к вашему хуку useData

const ExpensesPage = () => {
  const {
    data: expenses,
    isLoading: isExpensesLoading,
    error: expensesError,
    refetch,
  } = useData("/expenses", []);

  const { remove } = useData(`/products/expenses?contractId=0`, []);

  const [searchText, setSearchText] = useState("");
  const [searchedExpenses, setSearchedExpenses] = useState([]);

  useEffect(() => {
    if (expenses) {
      setSearchedExpenses([...expenses]);
    }
  }, [expenses]);

  const handleSearch = (value) => {
    setSearchText(value);
    const filteredExpenses =
      expenses?.filter((expense) =>
        Object.values(expense).some((item) =>
          String(item).toLowerCase().includes(value.toLowerCase()),
        ),
      ) || [];
    setSearchedExpenses(filteredExpenses);
  };

  const columns = [
    {
      title: "Название",
      dataIndex: "expenseName",
      key: "expenseName",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Поиск по названию`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Сбросить
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        record.expenseName?.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
      render: (text) => `${Number(text).toFixed(2)} ₾`,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: "Кол-во",
      dataIndex: "quantity",
      key: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Всего",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (text) => `${Number(text).toFixed(2)} ₾`,

      sorter: (a, b) => a.totalPrice - b.totalPrice,
    },
    {
      title: "Номер контракта",
      dataIndex: "contractId",
      key: "contractId",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Поиск по номеру`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Сбросить
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        record.contractId?.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Имя заказчика",
      dataIndex: "clientName",
      key: "clientName",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Поиск по имени`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Сбросить
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        record.clientName?.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Удалить",
      key: "delete",
      render: (text, record) => (
        <Button
          shape={"round"}
          danger
          onClick={async () => {
            await remove(record._id);
            await refetch(); // Обновляем данные после удаления
          }}
          icon={<Trash size={12} />}
        />
      ),
    },
  ];

  // Статистика за сегодня
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayExpenses =
    expenses?.filter((expense) => {
      const expenseDate = new Date(expense.createdAt);
      expenseDate.setHours(0, 0, 0, 0);
      return expenseDate.getTime() === today.getTime();
    }) || [];

  const todayItemsCount = todayExpenses.reduce(
    (sum, expense) => sum + expense.quantity,
    0,
  );
  const todayTotalPrice = todayExpenses.reduce(
    (sum, expense) => sum + expense.price * expense.quantity,
    0,
  );

  if (isExpensesLoading) {
    return <p>Загрузка данных...</p>;
  }

  if (expensesError) {
    return <p>Ошибка при загрузке данных.</p>;
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <h1>Список расходов (последние 100)</h1>
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <p>
              Сегодня добавлено <b>{todayItemsCount}</b> предметов на сумму{" "}
              <b>{todayTotalPrice.toFixed(2)} Лари</b>
            </p>
          </div>
          <Input
            placeholder="Поиск по всем полям"
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 300 }}
            prefix={<SearchOutlined />}
          />
        </div>
        <Table
          dataSource={searchedExpenses}
          columns={columns}
          rowKey={(record) => record._id.$oid}
          pagination={false}
          size={"small"}
        />
      </div>
    </div>
  );
};

export default ExpensesPage;
